<div class="form-group">
  <label class="control-label" for="inputcontrol" *ngIf="label && label.length">{{ label }}</label>
  <div class="input-wrapper">
    <textarea
      class="form-control"
      #input
      id="inputcontrol"
      [attr.disabled]="disabled || null"
      [attr.readonly]="readonly || null"
      [attr.placeholder]="placeholder"
      [attr.rows]="rows"
      [attr.cols]="cols || null"
      [attr.maxlength]="maxLength || null"
      [attr.minlength]="minLength || null"
      [ngClass]="{ disabled: disabled }"
      [(ngModel)]="value"
      (input)="onChange(input.value)"
    ></textarea>
    <ng-content select="[rx-error]" class="help-block"></ng-content>
  </div>
</div>
